export const getUnmaskedValue = (value?: string) => {
  if (value) {
    return value.replace(/\D+/g, "");
  }

  return "";
};
